import React from "react";
import PropTypes from 'prop-types';
import { RadioControl } from '@wordpress/components';

import Base from "../Base";
import withInput from "../../../hoc/withInput";

class RadioInput extends Base {
	getOptions() {
		const { options } = this.props;

		return Object.keys( options ).map( ( optionId ) => ( {
			label: options[optionId],
			value: optionId,
		} ) )
	}
	input() {
		const { inputValue, options } = this.props;
		
		return(
			<RadioControl options={ this.getOptions() } selected={ inputValue } onChange={ ( newValue ) => {
				this.onChange( newValue );
			} } />
		);
	}
}


RadioInput.propTypes = {
	inputValue: PropTypes.string,
};

export default withInput( RadioInput );
